<template>
  <div class="container">
    <h1>Calendario de Reservaciones</h1>
    <full-calendar :options="calendarOptions" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/init';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
  name: 'ReservationCalendar',
  components: {
    FullCalendar
  },
  setup() {
    const reservations = ref([]);

    const calendarOptions = ref({
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      events: [],
    });

    onMounted(() => {
      onSnapshot(collection(db, 'reservations'), (snapshot) => {
        reservations.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        updateCalendarEvents();
      });
    });

    const updateCalendarEvents = () => {
      calendarOptions.value.events = reservations.value.map(res => ({
        id: res.id,
        title: `Reserva para ${res.name}`,
        start: `${res.date}T${res.time}`
      }));
    };

    return {
      calendarOptions,
    };
  }
};
</script>

<style scoped>
.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}
</style>
